import { Injectable, Inject } from '@nestjs/common';
import { DistrictDTO, DistrictStatusDTO, getstatesDTO } from './dto/district.dto';
import { Repository, Raw, getConnection } from 'typeorm';
import { DistrictEntity} from './district.entity';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { DistrictResponseModel } from './dto/district-response.model';
import { AllDistrictResponseModel } from './dto/all-district-response.model';
import { DistrictStatusWiseResponseModel } from './dto/district-status-response.model';

@Injectable()
export class DistrictService {
  constructor(
    @InjectRepository(DistrictEntity)
    private districtRespository: Repository<DistrictEntity>,
  ){}
   
  async createDistrict(queryParams, districtDto:DistrictDTO, isUpdate:boolean,request:Request): Promise<DistrictResponseModel>{
    const response = new DistrictResponseModel();
    try{
      if(!isUpdate){
        const DistrictEntity = await this. getDistrictDetailsWithoutRelations(districtDto.districtName);
        if (DistrictEntity) {
          throw new ErrorResponse(11104, 'District already exists');
        } else {
          if (queryParams.apiVersion == 1){
            const savedDistrict = await this.districtRespository.save(districtDto);
            if (savedDistrict){
              response.status = true;
              response.data = savedDistrict;
              response.statusCode = 50000;
              response.internalMessage = 'District created successfullly';
              response.intlCode = 11100;
            } else{
              throw new ErrorResponse(11106,'District not created');
            }
          } else {
            const savedDistrict = await this .districtRespository.save(districtDto);
            if(savedDistrict){
              response.status = true;
              response.data = savedDistrict;
              response.statusCode = 50000;
              response.internalMessage = 'District created successfully';
              response.intlCode = 11100;
            } else {
              throw new ErrorResponse(11106,'District not created');
            }
          }      
        }
      } else {
        if (queryParams.apiVersion == 1) {
          const updatedDistrict = await this.districtRespository.update(districtDto.Id,districtDto);
          const updatedData = await this.districtRespository.findOne({
            where:{Id:districtDto.Id}
          });
          if (updatedDistrict) {
            response.status = true;
            response.data = updatedData;
            response.statusCode = 50000;
            response.internalMessage = 'District updated successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998,'District not updated');
          }
        } else {
          const updatedDistrict = await this.districtRespository.update(districtDto.Id,districtDto);
          const updatedData = await this. districtRespository.findOne({
            where:{Id:districtDto.Id}
          });
          if (updatedDistrict) {
            response.status = true;
            response.data = updatedData;
            response.statusCode = 50000;
            response.internalMessage = 'District updated successfully';
            response.intlCode = 11108;
          } else{
            throw new ErrorResponse(99998,'District not updated');
          }
        }       
      }
      return response ;
    } catch (error) {
      throw error;
    }
  }

  async getDistrictDetailsWithoutRelations (districtName: String): Promise<DistrictEntity>{ 
    const DistrictResposne = await this.districtRespository.findOne({
      where:{districtName: Raw(alias => `UPPER(district_name) = '${districtName.toLocaleUpperCase()}'`),status: true},
    });
    if (DistrictResposne) {
      return DistrictResposne;
    } else{
      return null;
    }
  }

  async getAllDistricts(queryParams, request:Request):Promise<AllDistrictResponseModel> {
    const response = new AllDistrictResponseModel();
    try {
      if (queryParams.apiVersion == 1) {
        const districts = await this.districtRespository.find({
          relations:['states'],
          order: { 'createdAt': 'DESC' }
        });
        if (districts) {
          response.status = true;
          response.data = districts;
          response.statusCode = 50000;
          response.internalMessage = 'Districts retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Districts not found');
        }
      } else {
        const districts = await this.districtRespository.find({
          relations:['states'],
          order: { 'createdAt': 'DESC' }
        });
        if (districts) {
          response.status = true;
          response.data = districts;
          response.statusCode = 50000;
          response.internalMessage = 'Districts retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Districts not found');
        }
      }
      return response;
    } catch (err) {
      throw err;
    }
  }

  async getDistrictByDistrictName(queryParams, districtName: string,request:Request): Promise<DistrictResponseModel> {
    const response = new DistrictResponseModel();
    try {
      if (queryParams.apiVersion == 1) {
        const districtResponse = await this.districtRespository.findOne({
          where:{districtName: Raw(alias =>`UPPER(district_name) = '${districtName.toLowerCase()}'`)}
        });
        if (districtResponse){
          response.status = true;
          response.data = districtResponse;
          response.statusCode = 50000;
          response.internalMessage = 'District record found';
          response.intlCode = 11107;
        } else {
         throw new ErrorResponse(99998,'District record not found');
        }
      } else {
        const districtResponse = await this.districtRespository.findOne({
         where:{districtName: Raw(alias =>`UPPER(district_name) = '${districtName.toLowerCase()}'`)}
        });
        if (districtResponse) {
          response.status = true;
          response.data = districtResponse;
          response.statusCode = 50000;
          response.internalMessage = 'District record found';
          response.intlCode = 11107;
        } else {
        throw new ErrorResponse(99998,'District record not found');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getDistrictByDistrictId(queryParams, districtId: number,request:Request):Promise <DistrictResponseModel> {
    const response = new DistrictResponseModel();
    try{
      if(queryParams.apiVersion == 1) {
        const districtResponse = await this. districtRespository.findOne({
          where:{Id: Raw(alias =>`id= '${districtId}'`)}
        });
        if (districtResponse) {
          response.status = true;
          response.data = districtResponse;
          response.statusCode = 50000;
          response.internalMessage = 'District record found';
          response.intlCode = 11107;
        } else {
          throw new ErrorResponse(99998,'District record not found');
        } 
      } else {
        const districtResponse = await this.districtRespository.findOne({
          where:{Id :Raw(alias =>`id= '${districtId}'`)}
        });
        if (districtResponse){
          response.status = true;
          response.data = districtResponse;
          response.statusCode = 50000;
          response.internalMessage = 'District record found';
          response.intlCode = 11107;
        } else{
          throw new ErrorResponse(99998, 'District record not found');
        }
      }
      return response;
    } catch(error) {
      throw error;
    }
  }

  async getAllActiveDistricts(queryParams,request:Request): Promise<AllDistrictResponseModel> {
    const response = new AllDistrictResponseModel();
    try {
      if(queryParams.apiVersion == 1) {
        const district = await this.districtRespository.find({
          where:{ status : true},
          order: { createdAt: 'DESC'}
        });
        if (district) {
          response.status = true;
          response.data = district;
          response.statusCode = 50000;
          response.internalMessage = 'Districts retrieved succesfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998,'Districts record not found');
        }
      } else{
        const district = await this.districtRespository.find({
          where:{status :true},
          order:{ createdAt: 'DESC'}
        });
        if (district) {
          response.status = true;
          response.data = district;
          response.statusCode = 50000;
          response.internalMessage = 'District retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse (99998,'District record not found');
        }
      }
      return response;
    }catch(err) {
      throw err;
    }
  }
         
  async getActiveDistrictsCount (queryParams, request:Request): Promise<DistrictStatusWiseResponseModel>{
    const response = new DistrictStatusWiseResponseModel();
    try {
      if (queryParams.apiVersion == 1) {
        const districtStatusWiseCount = await getConnection()
        .createQueryBuilder()
        .select("Sum(IF(ststus = true,1,0)) as activeCount,sum (IF(status = flase,1,0)) as inActiveCount, count(*) as cnt")
        .from(DistrictEntity, "district")
        .orderBy('status','ASC')
        .getRawOne();
        if (districtStatusWiseCount) {
          response.status = true;
          response.active = districtStatusWiseCount.activeCount;
          response.inActive = districtStatusWiseCount.inActiveCount;
          response.total = districtStatusWiseCount.cnt;
          response.statusCode = 50000;
          response.internalMessage = 'District retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse (99998, 'District not found');
        }
      } else {
        const districtStatusWiseCount = await getConnection()
        .createQueryBuilder()
        .select("Sum(IF(status = true, 1,0)) as activeCount, sum (IF(status = false, 1, 0)) as inActive, count(*) as cnt")
        .from(DistrictDTO,"district")
        .orderBy('status','ASC')
        .getRawOne();
        if (districtStatusWiseCount){
          response.status = true;
          response.active = districtStatusWiseCount.activeCount;
          response.inActive = districtStatusWiseCount.inActiveCount;
          response.total = districtStatusWiseCount.cnt;
          response.statusCode = 50000;
          response.internalMessage = 'District  retrieved successfully';
          response.intlCode = 11108;
        }else{
          throw new ErrorResponse(99998, 'District not found');
        }
      }
      return response;
    } catch (err) {
      throw err;
    }
  }

  async updateDistrictStatus(queryParams,districtStatusDto:DistrictStatusDTO,request:Request):Promise<DistrictResponseModel> {
    const response = new DistrictResponseModel();
    try {
      if(queryParams.apiVersion == 1) {
        await this.districtRespository.update(districtStatusDto.Id,districtStatusDto);
        const districts = await this.districtRespository.findOne({
          where: { Id:districtStatusDto.Id },
        });
        if (districts) {
          response.status = true;
          response.data = districts;
          response.statusCode = 50000;
          response.internalMessage = 'District status updated successfully';
          response.intlCode = 11108;
        } else {
        throw new ErrorResponse(99998, 'District status update failed');
        }
      } else {
        await this.districtRespository.update(districtStatusDto.Id,districtStatusDto);
        const districts = await this.districtRespository.findOne({
          where: { Id:districtStatusDto.Id },
        });
        if (districts) {
          response.status = true;
          response.data = districts;
          response.statusCode = 50000;
          response.internalMessage = 'District status updated successfully';
          response.intlCode = 11108;
        } else {
        throw new ErrorResponse(99998, 'District status update failed');
        }
      }      
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getdistrictbystateid(queryParams, getstatesDTO:getstatesDTO, request: Request): Promise<AllDistrictResponseModel> {
    const response = new AllDistrictResponseModel();
    try {
        if(queryParams.apiVersion == 1) {
            const activeTypes = await this.districtRespository.find({
                relations:['states'],
                where: {stateId:getstatesDTO.stateId,  status: true},

                order: { createdAt: 'DESC' }
            });
            if(activeTypes) {
                response.status = true;
                response.data = activeTypes;
                response.statusCode = 50000;
                response.internalMessage = 'data retrieved successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } else {
          const activeTypes = await this.districtRespository.find({
            
            where: {stateId:getstatesDTO.stateId,  status: true},
            //relations:['states'],
            order: { createdAt: 'DESC' }
        });
        if(activeTypes) {
            response.status = true;
            response.data = activeTypes;
            response.statusCode = 50000;
            response.internalMessage = 'data retrieved successfully';
            response.intlCode = 11108;
        } else {
            throw new ErrorResponse(99998, 'Data not found');
        }
        }
        return response;
    } catch (error) {
        throw error;
    }
}
}
    